import React, { useState } from 'react';
import { validateDigit } from '../../../utils/validation';
import CustomInput from '../../UI/CustomInput';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import { Box, IconButton, InputAdornment } from '@mui/material';
import useStyles from './useStyles';

const SearchComponent = ({ getAllUsers }) => {
  const classes = useStyles();

  const [name, setName] = useState('');

  const onClickSearchIcon = () => getAllUsers(name);

  return (
    <Box className={classes.mainContainer}>
      <CustomInput
        label={name ? 'نام' : ''}
        placeholder='نام'
        value={name}
        maxLength={20}
        onEnter={onClickSearchIcon}
        InputProps={{
          endAdornment: (
            <InputAdornment position='end'>
              <IconButton onClick={onClickSearchIcon}>
                <SearchRoundedIcon color='secondary' />
              </IconButton>
            </InputAdornment>
          ),
        }}
        onChangeHandler={(value) => {
          const ignore = validateDigit(value);
          if (ignore) setName(value);
          if (!value) getAllUsers();
        }}
      />
    </Box>
  );
};

export default SearchComponent;
